import { TAB_SIZE } from "../constants/ThemeSetting";

export const authWithModal = (width) => {
	return width >= TAB_SIZE ? "75%" : "100%";
};
